import { Component, OnInit, ViewChild, Renderer2, ElementRef, AfterViewChecked, OnDestroy } from '@angular/core';
import { AbstractControlOptions, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from '@core/services/alert.service';
import { AppConstants } from '@app/@core/entities/app-constants';
import { AuthService } from '@app/@core/services/auth.service';
import { AdminSettingsMessages } from '@app/pages/admin-settings/admin.constants';
import { convertTextWithNumbers } from '@app/@core/util/number.util';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss'],
    standalone: false
})
export class ChangePasswordComponent implements OnInit, AfterViewChecked, OnDestroy {

    isTooltipVisible = false;
    isConfirmTooltipVisible = false;
    tooltipPosition: 'tooltip-top' = 'tooltip-top';  // always top

  @ViewChild('showhidepassword') password;
  @ViewChild('showhideconfirmpassword') confirmNewPassword;
  @ViewChild('showhideCurrentPassword') currentpassword;
  @ViewChild('vcode') vcode:ElementRef;
  @ViewChild('accept') accept:ElementRef;
  @ViewChild('langselect') langselect:ElementRef;
  showPassword!: boolean;
  showConfirmPassword!: boolean;
  showCurrentPassword!: boolean;
  changePasswordForm!: FormGroup;
  label!: string;
  errors = [];
  visible: boolean = false;
  showLanguage : boolean =true;
  isTimerDone: boolean = false;
  time: string;
  count: any;
  loader:boolean = false;
  attCount: number = 0;
  setFocus1: boolean;
  setFocus3: boolean;
  setFocus2: boolean;
  setFocus: boolean;
  passwordRequirements: any = [];
  convertTextWithNumbers = convertTextWithNumbers;

  constructor(
    private _router: Router,
    private fb: FormBuilder,
    private alertService: AlertService,
    private authService: AuthService,
    private renderer: Renderer2,
    private route: ActivatedRoute,
  ) {
    this.label = 'Submit';
    this.renderer.addClass(document.body, 'clsRemoveTranslate');
  }
  ngAfterViewChecked(): void {
    if (this.vcode && this.setFocus) {
        this.vcode.nativeElement.focus();
        this.setFocus=false;
    }
    if(this.accept && this.setFocus1){
      setTimeout(() => {
        this.accept.nativeElement.focus();
      }, 200);
        this.setFocus1=false;
    }
    if(this.langselect && this.setFocus2){
        this.langselect.nativeElement.focus();
        this.setFocus2=false;
    }
    if(this.setFocus3){
        let googleTranElement = document.getElementById('google_translate_element');
        googleTranElement.getElementsByTagName("select")[0].focus();
        this.setFocus3=false;
    }
}

  ngOnDestroy(): void {
    this.renderer.removeClass(document.body, 'clsRemoveTranslate');
  }

  ngOnInit(): void {
    this.timer(AppConstants.TIMEOUT_DURATION_IN_MINUTES);
    this.setFocus=true;
    this.fetchPasswordPolicy();
    this.initializeForgotPasswordForm();
  }

fetchPasswordPolicy() {
  this.authService.getPasswordPolicy().pipe(
    map((res: any) => {
      if (res.data) {
        return res.data.map(item => {
          if (item.children && item.children.length > 0) {
            item.children.push("- 1 lowercase letter");
          }
          return item;
        });
      }
      return [];
    }),
    catchError(err => {
      console.error('Error fetching password policy:', err);
      return of([]); 
    })
  ).subscribe({
    next: (policy) => {
      this.passwordRequirements = policy;
    }
  });
}


  initializeForgotPasswordForm() {
    this.changePasswordForm = this.fb.group(
      {
        currentpassword: ['', [Validators.required]],
        newPassword: ['', [Validators.required]],
        confirmNewPassword: ['', [Validators.required]],
      },{ validator: this.checkingPasswords } as AbstractControlOptions
    );
  }

  
  login() {
    // This is intentional
  }

  routeToLogin() {
    this.changePasswordForm.reset();
    this._router.navigate(['/auth/login']);
  }

  toggleShowPassword() {
    this.showPassword = !this.showPassword;
    if (this.showPassword) {
      this.password.nativeElement.type = AppConstants.changePasswordText;
    } else {
      this.password.nativeElement.type = AppConstants.changePasswordPassword;
    }
  }

  toggleShowConfirmPassword() {
    this.showConfirmPassword = !this.showConfirmPassword;
    if (this.showConfirmPassword) {
      this.confirmNewPassword.nativeElement.type = AppConstants.changePasswordText;
    } else {
      this.confirmNewPassword.nativeElement.type =
        AppConstants.changePasswordPassword;
    }
  }

  saveTempPassword(reqData) {
    this.authService.tempChangePassword(reqData).subscribe(
      {next: (res) => {
      console.log(res);
      if (res) {
        this.alertService.success('Your password was created successfully. Please log in.', true);
        this._router.navigate(['/auth/login']);
      }
    },
    error:(err) => {
      if (err.error) {
        if(err?.error?.message) {
          if(err?.error?.message == 'Verification code retry attempt exceeded.'){
            this.routeToLogin();
          }
          this.alertService.error(err?.error?.message);
        } else if(err?.error?.errors) {
          this.alertService.error(err?.error?.errors)
        } else {
          this.alertService.error(AppConstants.errorMessage);
        }
      }
      this.label = 'Submit';
    }
      }
    );
  }

  save() {
    this.attCount = this.attCount + 1;
    if (this.confirmPwd()) {
      if (this.isTimerDone) {
        this.alertService.error('Verification Code expired.');
      } else {
        this.label = 'Please wait ...';
        const id = sessionStorage.getItem('id');
        const req = {
          id: Number(id),
          currentpassword: this.changePasswordForm.value['currentpassword'].trim(),
          newpassword: this.changePasswordForm.value['confirmNewPassword'],
        };
        const email = this.route.snapshot.queryParams.email;
        const newPassword = this.changePasswordForm.value['confirmNewPassword'];
        // Check if new password matches email
        if (email && newPassword) {
          const emailLower = email.trim().toLowerCase();
          const passwordLower = newPassword.trim().toLowerCase();
          const emailUsername = emailLower.split('@')[0];
          
          if (passwordLower.includes(emailLower) ||
              passwordLower.includes(emailUsername)) {
              this.alertService.error(AdminSettingsMessages.PASSWORD_MATCH_ERROR);
              this.label = 'Submit';
              return;
          }
          for (let i = 0; i <= emailUsername.length - AppConstants.MIN_SUBSTRING_LENGTH; i++) {
              const substring = emailUsername.substr(i, AppConstants.MIN_SUBSTRING_LENGTH);
              if (passwordLower.includes(substring)) {
                this.alertService.error(AdminSettingsMessages.PASSWORD_MATCH_ERROR);
                this.label = 'Submit';
                return;
              }
          }
          if (AppConstants.dictionaryWords.some(word => passwordLower.includes(word))) {
            this.alertService.error(AdminSettingsMessages.PASSWORD_DICTIONARY_ERROR);
            this.label = 'Submit';
            return;
          }
        }
        if (this.route.snapshot.queryParams.isTempPassword === 'TEMP_PASSWORD_RESET') {
          const reqData = {
            id: Number(id),
            currentpassword: this.changePasswordForm.value['currentpassword'].trim(),
            newpassword: this.changePasswordForm.value['confirmNewPassword'],
            email: this.route.snapshot.queryParams.email,
            attempt: this.attCount
          };
          this.authService.passwordAuthCheck({ password: this.changePasswordForm.value['confirmNewPassword'] })
            .subscribe(
              {next:(res: any) => {
              this.errors = [];
              if (res?.data?.valid) {
                this.saveTempPassword(reqData);
              } else if (res?.data?.errors && res?.data?.errors.length > 0) {
                this.errors = res?.data?.errors;
                this.alertService.error('Password does not meet the requirements.');
                this.label = 'Submit';
              }
            },
             error: (error) => {
                this.alertService.error(error?.error?.message);
                this.label = 'Submit';
              }}
            );

        } else {
          this.authService.passwordAuthCheck({ password: this.changePasswordForm.value['confirmNewPassword'] })
            .subscribe({next:(res: any) => {
              this.label = 'Submit';
              this.errors = [];
              if (res?.data?.valid) {
                this.authService.changePassword(req).subscribe(
                  {next:(response) => {
                  this.alertService.success('Password changed successfully.', true);
                  console.log(response);
                  this._router.navigate(['/auth/login']);
                },
                  error:(error) => {
                    if (error.error) {
                      if (error?.error?.message) {
                        this.alertService.error(error?.error?.message)
                      } else if (error?.error?.errors) {
                        this.alertService.error(error?.error?.errors)
                      } else {
                        this.alertService.error(AppConstants.errorMessage);
                      }
                    }
                  }}
                );
              } else if (res?.data?.errors && res?.data?.errors.length > 0) {
                this.errors = res?.data?.errors;
              }
            },
              error:(err) => {
                this.alertService.error(err?.error?.message);
              }}
            );
        }
      }
    }
  }

  public checkingPasswords(formGroup: FormGroup) {
    if (
      formGroup.controls.newPassword.value &&
      formGroup.controls.confirmNewPassword.value
    ) {
      return formGroup.controls.newPassword.value === formGroup.controls.confirmNewPassword.value ? false : { "notMatched": true }
    }
    return false;
  }
  confirmPwd(): boolean{
    if(this.changePasswordForm.controls.newPassword.value === this.changePasswordForm.controls.currentpassword.value){
      this.alertService.error('New Password should not be the same as Old Password.');
      return false
    }
    return true
  }

  showLanguageDialog() {
    this.visible = true;
    this.setFocus1=true;
  }

  acceptLanguage() {
    this.visible = false;
    this.showLanguage = false;
    this.setFocus3 = true;
    let googleTranElement = document.getElementById('google_translate_element');
    googleTranElement.className = 'clsLangTrans';
  }
  close(){
    this.visible = false; 
    this.setFocus2 = true;
}
  onResend(){
    this.loader = true;
    this.isTimerDone = false;
    this.attCount = 0;
    this.changePasswordForm.patchValue({currentpassword:''});
    this.authService.validateMail({ email: this.route.snapshot.queryParams.email, isWeb: true}).subscribe(
    {next: (res: any) => {
        if(res){
          this.loader = false;
          this.alertService.success('Verification code sent successfully.');
          clearInterval(this.count);
          this.setFocus=true;
          this.time = null
          this.timer(AppConstants.TIMEOUT_DURATION_IN_MINUTES);
        }
      },
      error:(error) => {
        if (error.error) {
          if (error?.error?.message) {
            this.alertService.error(error?.error?.message);
          } else if (error?.error?.errors) {
            this.alertService.error(error?.error?.errors);
          } else {
            this.alertService.error(AppConstants.errorMessage);
          }
          this.loader = false;
          this.isTimerDone = true;
          clearInterval(this.count);
          this.time = null
          this.timer(AppConstants.TIMEOUT_DURATION_IN_MINUTES);
        }
      }}
    );
  }
  timer(minute) {
    let seconds: number = minute * 60;
    let textSec: any = "0";
    let statSec: number = 0;

    const prefix = minute < 10 ? "0" : "";

    this.count = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = "0" + statSec;
      } else textSec = statSec;

      this.time = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;

      if (seconds == 0) {
        this.isTimerDone = true;
        clearInterval(this.count);
        this.time = ''
      }
    }, 1000);
  }


      showTooltip(_event: MouseEvent | FocusEvent) {
  this.isTooltipVisible = true;
}

hideTooltip() {
  this.isTooltipVisible = false;
}


   showConfirmTooltip(_event: MouseEvent | FocusEvent) {
  this.isConfirmTooltipVisible = true;
}

hideConfirmTooltip() {
  this.isConfirmTooltipVisible = false;
}

}